import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Createaccount from '../Components/Create-account';
// import Breadcrumbs from '../Components/banner/New-banner';

function Signup() {
    return (
        <>
        <Combaintop/>
        {/* <Breadcrumbs/> */}
        <Createaccount/>
        <Combainbottom/>
        </>
    )
}

export default Signup;